import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { AppConfig } from 'src/app/config/app-config';
import { AppConfigService } from 'src/app/config/app-config.service';
import { AddressAccess } from './models/address-access';
import { AddressSearchResponse } from './models/address-search-response';
import { Matrikel } from './models/matrikel';
import { MatrikelSearchResponse } from './models/matrikel-search-response';

@Injectable({
  providedIn: 'root',
})
export class GeoSearchService {
  appConfig: AppConfig;

  constructor(private appConfigService: AppConfigService, private http: HttpClient) {
    this.appConfig = appConfigService.getConfig();
  }

  formatParams(params: any): string {
    return Object.keys(params)
      .map(paramName => {
        const paramValue = params[paramName];
        return `${paramName}=${encodeURIComponent(paramValue)}`;
      })
      .join('&');
  }

  search(term: string, area: string, resource: string, limit: number = 10) {
    return fetch(
      this.appConfig.geoServiceSearchUrl +
        resource +
        '?' +
        this.formatParams({
          q: term,
          area: area,
          token: this.appConfig.geoServiceSearchToken,
          limit: limit.toString(),
        }),
      {
        mode: 'cors',
      }
    );
  }

  searchMatrikel(
    term: string = '',
    area: string = '',
    limit: number = 10
  ): Observable<MatrikelSearchResponse> {
    return from(
      this.search(term, area, 'matrikel', limit).then(
        response =>
          response.json().then(json => {
            const matrikel: MatrikelSearchResponse = {
              data: json as Matrikel[],
              status: 'OK',
              message: '200',
            };
            return matrikel;
          }),
        error => {
          const matrikel: MatrikelSearchResponse = {
            data: [],
            status: '500',
            message: error,
          };
          return matrikel;
        }
      )
    );
  }

  searchAddress(term: string, area: string, limit: number = 10) {
    return from(
      this.search(term, area, 'adresse', limit).then(
        response =>
          response.json().then(json => {
            const address: AddressSearchResponse = {
              data: json as AddressAccess[],
              status: '200',
              message: 'OK',
            };
            return address;
          }),
        error => {
          const address: AddressSearchResponse = { data: null, status: '500', message: error };
          return address;
        }
      )
    );
  }
}
